<template>
  <!--
    评论的「···」更多菜单，对齐 App 端长按评论弹出的操作面板：
      分享给好友 / 私信 | 复制 / 添加到表情 / 举报 / 删除
    「回复」和「点赞」评论底部本来就有按钮，这里不重复。

    本组件只决定「显示哪几项」，点了哪一项交给父组件处理（action 事件）：
    删除要改评论列表、添加到表情要更新表情面板，这些状态都在 comment/index.vue 里。

    用 el-dropdown 而不是 el-popover：一页评论连同楼内预览的回复有几十条，
    el-popover 每个实例都会在 document 上挂一个 click 监听，el-dropdown 走 Clickoutside，全局只挂一个。
  -->
  <el-dropdown
    class="comment-action-menu"
    trigger="click"
    placement="bottom-end"
    @command="onCommand"
    @visible-change="menuOpen = $event"
  >
    <span
      class="comment-more-btn hand-style"
      :class="{ 'is-open': menuOpen }"
      title="更多"
      role="button"
      aria-label="更多操作"
    >
      <i class="el-icon-more"></i>
    </span>
    <el-dropdown-menu slot="dropdown" class="comment-action-dropdown">
      <el-dropdown-item
        v-for="action in actions"
        :key="action.key"
        :command="action.key"
        :icon="action.icon"
        :divided="action.divided"
        :class="['comment-action-item', 'comment-action-item--' + action.key, { 'is-danger': action.danger }]"
      >{{ action.label }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {
  isMyComment,
  canDeleteComment,
  canChatWithCommentUser,
  collectableStickerUrl
} from './commentActions'

export default {
  name: 'CommentActionMenu',
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      menuOpen: false
    }
  },
  computed: {
    actions () {
      const comment = this.comment
      const isMine = isMyComment(comment)

      // 第一组：分享类，和 App 端一样排在最前面
      const list = [{ key: 'share', label: '分享给好友', icon: 'el-icon-share' }]
      if (canChatWithCommentUser(comment)) {
        list.push({ key: 'chat', label: '私信', icon: 'el-icon-chat-dot-round' })
      }

      // 第二组：对这条评论本身的操作
      list.push({ key: 'copy', label: '复制', icon: 'el-icon-document-copy', divided: true })
      if (collectableStickerUrl(comment)) {
        list.push({ key: 'add-sticker', label: '添加到表情', icon: 'el-icon-circle-plus-outline' })
      }
      // 自己的评论不能举报自己；帖子作者看别人的评论，既能举报也能删
      if (!isMine) {
        list.push({ key: 'report', label: '举报', icon: 'el-icon-warning-outline' })
      }
      if (canDeleteComment(comment)) {
        // 不可逆操作，标红放最后（App 端同样是红色）
        list.push({ key: 'delete', label: '删除', icon: 'el-icon-delete', danger: true })
      }
      return list
    }
  },
  methods: {
    onCommand (key) {
      this.$emit('action', key)
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-action-menu {
  display: inline-flex;
  align-items: center;
  // el-dropdown 默认 color: #606266，会盖掉评论底部那一排的灰色
  color: inherit;
  font-size: inherit;
}

.comment-more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  color: #8a919f;
  transition: color 0.2s, background-color 0.2s;

  i {
    font-size: 14px;
  }

  &:hover,
  &.is-open {
    color: var(--theme-color);
    background-color: rgba(0, 0, 0, 0.04);
  }
}
</style>

<style lang="scss">
/* 下拉菜单挂在 body 上，scoped 样式管不到里面的图标，统一写在这里，类名带前缀避免串到别处 */
.comment-action-dropdown {
  min-width: 132px;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 34px;

    i {
      margin-right: 8px;
      font-size: 14px;
    }
  }

  .el-dropdown-menu__item.is-danger,
  .el-dropdown-menu__item.is-danger:not(.is-disabled):hover,
  .el-dropdown-menu__item.is-danger:focus {
    color: #f56c6c;
  }

  .el-dropdown-menu__item.is-danger:not(.is-disabled):hover,
  .el-dropdown-menu__item.is-danger:focus {
    background-color: #fef0f0;
  }
}
</style>
